var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-overview-w"},[_c('div',{staticClass:"group-w"},[_c('div',{staticClass:"group"},[_c('item-card',{attrs:{"items":_vm.itemsDetail},on:{"subtotal-change":_vm.updateSubtotal,"to-item":_vm.toItem}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }